import { render, staticRenderFns } from "./TransactionInside.vue?vue&type=template&id=31189a33&scoped=true&"
import script from "./TransactionInside.vue?vue&type=script&lang=js&"
export * from "./TransactionInside.vue?vue&type=script&lang=js&"
import style0 from "./TransactionInside.vue?vue&type=style&index=0&id=31189a33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31189a33",
  null
  
)

export default component.exports